import { render, staticRenderFns } from "./eventProfile.vue?vue&type=template&id=2470abf4&scoped=true&"
import script from "./eventProfile.vue?vue&type=script&lang=js&"
export * from "./eventProfile.vue?vue&type=script&lang=js&"
import style0 from "./eventProfile.vue?vue&type=style&index=0&id=2470abf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470abf4",
  null
  
)

export default component.exports